import StudySummary from './StudySummary.tsx';

export default StudySummary;
